import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

const lineVariants = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.1, delay: i * 0.12, ease: EASE } }),
};

// Masked line-by-line reveal; observer lives on the unclipped wrapper.
export const MaskLines = ({ lines, className = "", onLoad = false, delay = 0, as = "h2", testId }) => {
  const Tag = motion[as];
  const trigger = onLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.15 } };
  return (
    <Tag className={className} initial="hidden" {...trigger} data-testid={testId}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span className="block" variants={lineVariants} custom={i + delay / 0.12}>
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const Overline = ({ children, className = "" }) => (
  <p className={`font-mono-rc text-xs uppercase tracking-[0.28em] text-rc-copper ${className}`}>{children}</p>
);
